import React from 'react';
import { jobVacancyStore } from './JobVacancyStore';
import JobVacanciesTable from './JobVacanciesTable';
import { ListStore } from 'shared/stores/ListStore';
import { observer } from 'mobx-react';
import { eventManager } from 'ats/utils/EventManager';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';
import { modalStore } from 'components/layout/modals/ModalStore';
import { JobVacancyCreate } from './components/JobVacancyCreate';

@observer
export class JobPositionVacancies extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(jobVacancyStore, {
			entityName: 'Job Vacancy'
		});
	}

	loadVacancies = jobPosition => {
		if (!jobPosition?.id) return;

		jobVacancyStore.setQuery('jobId', jobPosition.id);
		jobVacancyStore.setQuery('sort', {
			column: 'createdAt',
			asc: false
		});
		this.listStore.search();
	};

	componentDidMount() {
		this.loadVacancies(this.props.jobPosition);
		eventManager.on(
			'jobApplicationStageChanged',
			this.handleJobApplicationStageChanged
		);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.jobPosition?.id !== this.props.jobPosition?.id) {
			this.loadVacancies(this.props.jobPosition);
		}
	}

	handleJobApplicationStageChanged = ({ jobId, stage }) => {
		if (jobId === this.props.jobPosition.id && stage === 'hired') {
			this.listStore.search();
		}
	};

	componentWillUnmount() {
		eventManager.off(
			'jobApplicationStageChanged',
			this.handleJobApplicationStageChanged
		);
	}

	openAddVacancyModal = () => {
		modalStore.openModal(
			{ title: 'Create Job Vacancy', size: 'xl', position: 'center' },
			<JobVacancyCreate
				job={this.props.jobPosition}
				handleSuccess={() => {
					this.listStore.search();
					this.props.onSuccess?.();
				}}
			/>
		);
	};

	render() {
		const showEmptyState =
			!this.listStore.loading && this.listStore.data.length === 0;

		return (
			<div className="job-position-vacancies">
				<JobVacanciesTable
					data={this.listStore.data}
					sort={this.listStore.store.query.sort}
					onSort={this.listStore.handleSort}
					isEmpty={showEmptyState}
					emptyState={
						<EmptyState
							icon={EMPTY_STATE_ICONS.sheet}
							iconAlt="No vacancies"
							message="No vacancies have been added yet."
							actionText="Add Vacancy"
							onActionClick={this.openAddVacancyModal}
						/>
					}
					onSuccess={() => {
						this.listStore.search();
						this.props.onSuccess?.();
					}}
				/>
			</div>
		);
	}
}
